<template>
	<div class="maintenance">

    <h1>Down for Maintenance</h1>

  </div>
</template>

<script>
export default {
  name: 'Maintenance',
}
</script>

<style>
  .maintenance {
    display: flex;
    width: 100vw;
    height: 100vh;
    justify-content: center;
    align-items: center;
    color: white;
  }
</style>
